import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import makeRequest from './makeRequest';
var url = "".concat(process.env.REACT_APP_BASE_URL, "/auth/et/token");
export default function authenticateEtToken(_x) {
  return _authenticateEtToken.apply(this, arguments);
}

function _authenticateEtToken() {
  _authenticateEtToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(token) {
    var response, responseJson;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return makeRequest({
              url: url,
              method: 'POST',
              data: {
                token: token
              }
            });

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.json();

          case 5:
            responseJson = _context.sent;

            if (!responseJson) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", responseJson.token);

          case 8:
            return _context.abrupt("return", null);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _authenticateEtToken.apply(this, arguments);
}